import styles from './styles';
import Alert from '@mui/material/Alert';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CheckBox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import React, { useLayoutEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';

export default ({ hideAcknowledgeCheckbox, acknowledgedPolicy, onAckChecked, isFinemark }) => {
    const [isAckLabelMultiline, setIsAckLabelMultiline] = useState(false);

    const labelRef = useRef(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useLayoutEffect(() => {
        const label = labelRef.current;
        if (!label) return;

        const checkMultiline = () => {
            const lineHeight = parseFloat(window.getComputedStyle(label).lineHeight);
            setIsAckLabelMultiline(label.scrollHeight > lineHeight + 1);
        };

        checkMultiline();

        new ResizeObserver(checkMultiline).observe(label);
    });


    return (
        <Alert variant="outlined" severity="warning" color="info" sx={styles.alert}
               icon={!isMobile && <ReportProblemOutlined sx={styles.alertIcon} />}
        >
            <AlertTitle sx={styles.alertTitle}>
                <Stack direction='row'>
                    { isMobile && <ReportProblemOutlined sx={styles.alertIconMobile} /> }
                    Protect Your Credentials
                </Stack>
            </AlertTitle>
            For your security, Commerce Bank will <span style={{ fontWeight: 'bold', }}>NEVER </span>
            ask for your password, answers to security questions, or multi-factor authentication
            codes by phone, text, or email. If anyone does, please immediately contact Commercial
            Customer Support at {isFinemark ? '877-461-5901' : '800-207-0886'}.
            { !hideAcknowledgeCheckbox && (
                <FormGroup>
                    <FormControlLabel
                            control={
                                <CheckBox sx={styles.checkbox}
                                          checked={acknowledgedPolicy}
                                          onChange={onAckChecked} />
                            }
                            label={
                                <Box sx={{ display: 'inline-block', }} ref={labelRef}>
                                    I acknowledge the security policy above
                                </Box>
                            }
                            sx={theme => styles.checkboxLabel(theme, isAckLabelMultiline)}
                    />
                </FormGroup>
            )}
        </Alert>
    )
}